/* global axios */

import ApiClient from './ApiClient';

class DaftaraAPI extends ApiClient {
  constructor() {
    super('daftara', { accountScoped: true });
  }

  status() {
    return axios.get(`${this.url}/status`);
  }

  connect(payload) {
    return axios.post(`${this.url}/connect`, payload);
  }

  siteInfo() {
    return axios.get(`${this.url}/site_info`);
  }

  clients(params = {}) {
    return axios.get(`${this.url}/clients`, { params });
  }

  products(params = {}) {
    return axios.get(`${this.url}/products`, { params });
  }

  productCategories(params = {}) {
    return axios.get(`${this.url}/product_categories`, { params });
  }

  invoices(params = {}) {
    return axios.get(`${this.url}/invoices`, { params });
  }

  invoicePayments(params = {}) {
    return axios.get(`${this.url}/invoice_payments`, { params });
  }

  clientPayments(params = {}) {
    return axios.get(`${this.url}/client_payments`, { params });
  }

  invoiceAppointments(params = {}) {
    return axios.get(`${this.url}/invoice_appointments`, { params });
  }

  bookings(params = {}) {
    return axios.get(`${this.url}/bookings`, { params });
  }

  packages(params = {}) {
    return axios.get(`${this.url}/packages`, { params });
  }

  creditUsages(params = {}) {
    return axios.get(`${this.url}/credit_usages`, { params });
  }

  creditCharges(params = {}) {
    return axios.get(`${this.url}/credit_charges`, { params });
  }

  followUpStatuses(params = {}) {
    return axios.get(`${this.url}/follow_up_statuses`, { params });
  }

  followUpActions(params = {}) {
    return axios.get(`${this.url}/follow_up_actions`, { params });
  }

  appStatus(appId) {
    return axios.get(`${this.url}/app_status`, { params: { app_id: appId } });
  }

  addCreditUsage(creditUsage) {
    return axios.post(`${this.url}/add_credit_usage`, { credit_usage: creditUsage });
  }

  importClient(client) {
    return axios.post(`${this.url}/import_client`, { client });
  }

  createConversation(payload) {
    return axios.post(`${this.url}/create_conversation`, payload);
  }

  updateSettings(payload) {
    return axios.patch(`${this.url}/settings`, payload);
  }

  disconnect() {
    return axios.delete(`${this.url}/disconnect`);
  }
}

export default new DaftaraAPI();
